import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

/**
 * FormSubmitButton Component
 * Reusable submit button with loading state
 * Uses PrimeNG Button for styling and responsiveness
 * Supports dynamic loading text and disabled states
 */
@Component({
  selector: 'app-form-submit-button',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './form-submit-button.html',
  styleUrl: './form-submit-button.scss',
})
export class FormSubmitButton {
  @Input() type: 'button' | 'submit' = 'submit';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() label: string = 'Submit';
  @Input() loadingLabel: string = 'Processing...';
  @Input() buttonClass: string =
    'w-full bg-botmaaOrange hover:bg-botmaaOrange text-white botmaSubmit  font-medium py-2.5 rounded-md shadow-md transition duration-200';
  @Input() disabledClass: string = 'opacity-60 cursor-not-allowed';

  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled && !this.loading) {
      this.clicked.emit();
    }
  }

  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  get displayText(): string {
    return this.loading ? this.loadingLabel : this.label;
  }
}
